import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { BrokenContainerReportFieldsFragmentDoc } from './brokenContainerReport.generated';
export type OpsOrderDetailFragment = { __typename?: 'OpsOrderDetail', id: string, type?: Types.MerchantOrderTypeEnum | null, system: string, status: Types.MerchantOrderStatusEnum, store_name?: string | null, store_text_id?: string | null, city?: string | null, country?: string | null, created_at: string, health: string, carrier?: Types.OpsOrderCarrier | null, last_updated: string, warehouse?: string | null, warehouse_uuid?: string | null, warehouse_is_automatic: boolean, item_location?: string | null, delivery_date?: string | null, package_count: number, package_weights: Array<number>, carrier_service?: Types.OpsOrderCarrierService | null, language?: string | null, order_execution_date?: string | null, carrier_pickup_date?: string | null, comment?: string | null, ops_comment?: string | null, return_reasons: Array<Types.ReturnOrderReason>, return_reason_text?: string | null, event_start_date?: string | null, event_end_date?: string | null, event_manager?: string | null, target_store_user_id?: string | null, error_type?: Types.MerchantOrderErrorTypeEnum | null, order_form_id?: string | null, order_form_deadline?: string | null, error_message?: string | null, container_types_used_detail: Array<{ __typename?: 'ContainerType', id: number, name: string, image_url?: string | null, image?: string | null, packing_unit?: number | null, color_hex_code?: string | null, segment?: Types.ContainerTypeSegment | null, size_helper?: string | null }>, created_by?: { __typename?: 'IdName', id: string, name: string } | null, containers: Array<{ __typename?: 'OpsOrderContainer', amount: number, disabled: boolean, disabled_until?: string | null, id: string, item_location_id?: string | null, item_location_name?: string | null, sales_order_url?: string | null, type: { __typename?: 'OpsOrderContainerType', box_count: number, id: number, image_url?: string | null, name?: string | null, packing_unit: number, purchase_price_cents?: number | null } }>, untracked_items: Array<{ __typename?: 'OpsOrderUntrackedItem', id: string, amount: number, item_location_id?: string | null, item_location_name?: string | null, name?: string | null, type: { __typename?: 'OpsOrderUntrackedItemType', id: number, name?: string | null, image_url?: string | null } }>, items: Array<{ __typename?: 'OpsOrderItem', id: string, amount: number, item_location_id?: string | null, item_location_name?: string | null, name?: string | null, item_type: { __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null } }>, delivery_address?: { __typename?: 'DeliveryAddressInfo', additional_info?: string | null, city?: string | null, company?: string | null, country?: string | null, email?: string | null, first_name?: string | null, id: string, last_name?: string | null, name?: string | null, phone_number?: string | null, streetname?: string | null, streetno?: string | null, zip?: string | null } | null, available_carrier_services: Array<{ __typename?: 'AvailableCarrierService', carrier: Types.OpsOrderCarrier, services: Array<Types.OpsOrderCarrierService> }>, carrier_validation_rules: Array<{ __typename?: 'OpsOrderCarrierValidationRules', carrier: Types.OpsOrderCarrier, validation_rules: { __typename?: 'OpsOrderValidationRules', name: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, company: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, streetname: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, additional_info: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, city: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, zip: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, phone_number: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, email: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, country: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport } } }>, return_containers?: { __typename?: 'ReturnOrderContainerSummary', lines: Array<{ __typename?: 'ReturnOrderContainerLine', container_type_id: number, amount: number, identified: number, counted: number }>, removed_containers: Array<{ __typename?: 'ReturnOrderRemovedContainer', id: string, name?: string | null, short_id?: string | null, container_type_id: number, reason: Types.ReturnOrderContainerRemovalReason, removed_at: string }> } | null, return_intake?: { __typename?: 'ReturnOrderIntake', id: string, status: Types.MerchantOrderStatusEnum, completed_at?: string | null, containers: Array<{ __typename?: 'ReturnOrderIntakeContainerLine', container_type_id: number, name?: string | null, image_url?: string | null, announced: number, identified: number, counted: number, received?: number | null, scan_required: boolean, broken?: number | null, reported_broken: number, scanned_containers: Array<{ __typename?: 'ReturnOrderIntakeScannedContainer', id: string, name?: string | null, short_id?: string | null, announced: boolean, source: Types.ReturnOrderContainerSource }>, missing_containers: Array<{ __typename?: 'ReturnOrderIntakeContainer', id: string, name?: string | null, short_id?: string | null }> }>, store_assets: Array<{ __typename?: 'ReturnOrderIntakeStoreAssetLine', item_type_id: number, name?: string | null, image_url?: string | null, announced: number, received?: number | null }>, untracked_items: Array<{ __typename?: 'ReturnOrderIntakeUntrackedItemLine', type_id: number, name?: string | null, announced: number, received?: number | null }>, photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }>, partner_photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }> } | null, return_follow_up?: { __typename?: 'ReturnOrderFollowUp', id: string, discrepancy_status?: Types.ReturnOrderDiscrepancyStatus | null, discrepancy_mail_sent_at?: string | null, resolved_at?: string | null, resolved_by?: string | null, resolution_note?: string | null, parcel_lost_at?: string | null, parcel_lost_by?: string | null, lost_container_count: number, can_set_parcel_lost: boolean, discrepancy_lines: Array<{ __typename?: 'ReturnOrderDiscrepancyLine', kind: Types.ReturnOrderLineKind, type_id: number, name?: string | null, announced: number, received: number, difference: number }> } | null, return_broken_reports?: Array<{ __typename?: 'BrokenContainerReport', id: string, store_id: string, store_name?: string | null, context: Types.BrokenContainerReportContext, merchant_order_id?: string | null, merchant_order_delivery_note_id?: number | null, comment?: string | null, created_at: string, created_by?: string | null, container_total: number, lines: Array<{ __typename?: 'BrokenContainerLine', id: string, container_type_id: number, container_type_name?: string | null, image_url?: string | null, amount: number, part: Types.BrokenContainerPart, active?: boolean | null, cleared_at?: string | null, cleared_by?: string | null, container?: { __typename?: 'ReturnOrderContainer', id: string, name?: string | null, short_id?: string | null } | null, photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }> }>, photos: Array<{ __typename?: 'OrderFulfillmentPicture', id: string, url_full_size: string, created_at: string, thumbnail_url: string }> }> | null, status_history: Array<{ __typename?: 'OpsOrderStatusHistory', changed_by?: string | null, comment?: string | null, status: Types.MerchantOrderStatusEnum, timestamp: string }>, carrier_status: Array<{ __typename?: 'OpsOrderCarrierStatus', status?: string | null, status_details?: string | null, tracking_code: string, updated_at?: string | null, shipment_attempt_number?: number | null, is_superseded: boolean, parcel_id?: string | null, is_replacement: boolean }>, validation_rules: { __typename?: 'OpsOrderValidationRules', name: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, company: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, streetname: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, additional_info: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, city: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, zip: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, phone_number: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, email: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, country: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport } }, internal_transactions: Array<{ __typename?: 'OpsOrderInternalTransaction', amount?: string | null, created_at?: string | null, description?: string | null, id: string, type?: string | null }>, event_ordered_totals?: { __typename?: 'EventOrderedTotals', container_types: Array<{ __typename?: 'EventOrderedContainerTotal', ordered: number, type: { __typename?: 'OpsOrderContainerType', id: number, name?: string | null, image_url?: string | null } }>, item_types: Array<{ __typename?: 'EventOrderedItemTotal', ordered: number, type: { __typename?: 'OpsOrderUntrackedItemType', id: number, name?: string | null, image_url?: string | null } }> } | null, picking_job?: { __typename?: 'OpsOrderPickingJobLink', id: string, status: Types.PickingJobStatus, carrier_pickup_date?: string | null, total_amount_ordered: number, total_amount_picked: number, resolution?: { __typename?: 'PickingJobResolution', destination: Types.PickingJobResolutionDestination, resolved_at: string, reason: string, resolved_by?: { __typename?: 'IdName', id: string, name: string } | null } | null } | null };

export type ReturnOrderFollowUpFieldsFragment = { __typename?: 'ReturnOrderFollowUp', id: string, discrepancy_status?: Types.ReturnOrderDiscrepancyStatus | null, discrepancy_mail_sent_at?: string | null, resolved_at?: string | null, resolved_by?: string | null, resolution_note?: string | null, parcel_lost_at?: string | null, parcel_lost_by?: string | null, lost_container_count: number, can_set_parcel_lost: boolean, discrepancy_lines: Array<{ __typename?: 'ReturnOrderDiscrepancyLine', kind: Types.ReturnOrderLineKind, type_id: number, name?: string | null, announced: number, received: number, difference: number }> };

export const ReturnOrderFollowUpFieldsFragmentDoc = gql`
    fragment ReturnOrderFollowUpFields on ReturnOrderFollowUp {
  id
  discrepancy_status
  discrepancy_lines {
    kind
    type_id
    name
    announced
    received
    difference
  }
  discrepancy_mail_sent_at
  resolved_at
  resolved_by
  resolution_note
  parcel_lost_at
  parcel_lost_by
  lost_container_count
  can_set_parcel_lost
}
    `;
export const OpsOrderDetailFragmentDoc = gql`
    fragment OpsOrderDetail on OpsOrderDetail {
  id
  type
  system
  container_types_used_detail: container_types_used {
    id
    name
    image_url
    image
    packing_unit
    color_hex_code
    segment
    size_helper
  }
  status
  store_name
  store_text_id
  city
  country
  created_at
  health
  carrier
  last_updated
  created_by {
    id
    name
  }
  warehouse
  warehouse_uuid
  warehouse_is_automatic
  item_location
  delivery_date
  containers {
    amount
    disabled
    disabled_until
    id
    item_location_id
    item_location_name
    sales_order_url
    type {
      box_count
      id
      image_url
      name
      packing_unit
      purchase_price_cents
    }
  }
  untracked_items {
    id
    amount
    item_location_id
    item_location_name
    name
    type {
      id
      name
      image_url
    }
  }
  items {
    id
    amount
    item_location_id
    item_location_name
    name
    item_type {
      id
      name
      image_url
      color_hex_code
    }
  }
  package_count
  package_weights
  delivery_address {
    additional_info
    city
    company
    country
    email
    first_name
    id
    last_name
    name
    phone_number
    streetname
    streetno
    zip
  }
  carrier_service
  available_carrier_services {
    carrier
    services
  }
  carrier_validation_rules {
    carrier
    validation_rules {
      name {
        max
        min
        regex
        support
      }
      company {
        max
        min
        regex
        support
      }
      streetname {
        max
        min
        regex
        support
      }
      additional_info {
        max
        min
        regex
        support
      }
      city {
        max
        min
        regex
        support
      }
      zip {
        max
        min
        regex
        support
      }
      phone_number {
        max
        min
        regex
        support
      }
      email {
        max
        min
        regex
        support
      }
      country {
        max
        min
        regex
        support
      }
    }
  }
  language
  type
  order_execution_date
  carrier_pickup_date
  comment
  ops_comment
  return_reasons
  return_reason_text
  return_containers {
    lines {
      container_type_id
      amount
      identified
      counted
    }
    removed_containers {
      id
      name
      short_id
      container_type_id
      reason
      removed_at
    }
  }
  return_intake {
    id
    status
    completed_at
    containers {
      container_type_id
      name
      image_url
      announced
      identified
      counted
      received
      scan_required
      scanned_containers {
        id
        name
        short_id
        announced
        source
      }
      missing_containers {
        id
        name
        short_id
      }
      broken
      reported_broken
    }
    store_assets {
      item_type_id
      name
      image_url
      announced
      received
    }
    untracked_items {
      type_id
      name
      announced
      received
    }
    photos {
      id
      thumbnail_url: url
      url_full_size
      created_at
    }
    partner_photos {
      id
      thumbnail_url: url
      url_full_size
      created_at
    }
  }
  return_follow_up {
    ...ReturnOrderFollowUpFields
  }
  return_broken_reports {
    ...BrokenContainerReportFields
  }
  status_history {
    changed_by
    comment
    status
    timestamp
  }
  carrier_status {
    status
    status_details
    tracking_code
    updated_at
    shipment_attempt_number
    is_superseded
    parcel_id
    is_replacement
  }
  validation_rules {
    name {
      max
      min
      regex
      support
    }
    company {
      max
      min
      regex
      support
    }
    streetname {
      max
      min
      regex
      support
    }
    additional_info {
      max
      min
      regex
      support
    }
    city {
      max
      min
      regex
      support
    }
    zip {
      max
      min
      regex
      support
    }
    phone_number {
      max
      min
      regex
      support
    }
    email {
      max
      min
      regex
      support
    }
    country {
      max
      min
      regex
      support
    }
  }
  internal_transactions {
    amount
    created_at
    description
    id
    type
  }
  event_start_date
  event_end_date
  event_manager
  target_store_user_id
  error_type
  order_form_id
  order_form_deadline
  error_message
  event_ordered_totals {
    container_types {
      type {
        id
        name
        image_url
      }
      ordered
    }
    item_types {
      type {
        id
        name
        image_url
      }
      ordered
    }
  }
  picking_job {
    id
    status
    carrier_pickup_date
    total_amount_ordered
    total_amount_picked
    resolution {
      destination
      resolved_at
      resolved_by {
        id
        name
      }
      reason
    }
  }
}
    ${ReturnOrderFollowUpFieldsFragmentDoc}
${BrokenContainerReportFieldsFragmentDoc}`;